import axios from "axios";
import {getHostApi, getRequestConfig} from "../../../../utils";

export async function _getVariableNbCouleurs() {
  return await axios.get(`${getHostApi()}/shops/variables/nombre_couleurs_broderie`, getRequestConfig());
}

export async function _getFeatureNbCouleurs() {
  return await axios.get(`${getHostApi()}/shops/features/broderie_new_im_version`, getRequestConfig());
}

export async function _checkCanReUse(url: {routeFetchFils: string, tiff: string, traitementContour: string}){
  return await axios.post(url.routeFetchFils, {tiff: url.tiff, traitementContour: url.traitementContour}, getRequestConfig());
}